

import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import { Image, Video } from 'cloudinary-react';
import Dashboard from '../Dashboard/Dashboard';
// import Users from '../Users/Users';
// import Ticket from '../Ticket/Ticket';
import Notifications from '../Notifications/Notifications';
import { Routes, Route, useNavigate, Link, Outlet } from "react-router-dom";
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import StarBorder from '@mui/icons-material/StarBorder';
import Homepage from "../Homepage/Homepage";
import UserTicket from "../UserTicket/UserTicket";
// import Roles from "../Roles/Roles";
import { FaBars } from 'react-icons/fa';
import { Button } from "@mui/material";
import DrawerStyles from './Drawer.module.css'
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LogoutIcon from '@mui/icons-material/Logout';


import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
// import SearchIcon from "@mui/icons-material/Search";

import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';

// import axios from "axios";
import { setLogout } from '../../state/GlobalState'
import NotificationsSharpIcon from '@mui/icons-material/NotificationsSharp';
import { useLocation } from 'react-router-dom';

import Badge from "@mui/material/Badge";
import ButtonGroup from "@mui/material/ButtonGroup";

// import AddIcon from "@mui/icons-material/Add";


// this is the import line from redux selector and dipatch
import { useSelector, useDispatch } from 'react-redux'

import { setNotificationCount } from "../../state/GlobalState";





import AccountCircleIcon from '@mui/icons-material/AccountCircle';


const drawerWidth = 240;

// Responsive code

export default function ClippedDrawer() {

  const [selectedTab, setSelectedTab] = useState("Dashboard");

  // Function to handle tab selection
  const handleTabClick = (tabName) => {
    setSelectedTab(tabName);
  };
  // const [count, setCount] = React.useState(0);

  // const resetCount = () => {
  //   setCount(0);
  // };

  const location = useLocation();

  // const navigate = useNavigate()
  const [login, setLogin] = useState(false)
  // const [user, setUser] = useState(undefined)
  const [mail, setMail] = useState(undefined)
  const dispatch = useDispatch();
  // useEffect(() => {
  //   setLogin(isLoggedIn())
  //   const data = JSON.parse(localStorage.getItem('data'))
  //   setUser(data?.name || data?.sendDetails?.name)
  //   // setMail(data?.usernameOrEmail || data?.sendDetails?.usernameOrEmail)
  // }, [login])

  const logout = () => {

    dispatch(setLogout())

  }


  // this is the line to get data from redux
  const count = useSelector((state) => state.globalData.notificationCount);
  const user = useSelector((state) => state.globalData.user);
  const name = useSelector((state) => state.globalData.name);
  // const details=useSelector((state)=>state.globalData.details);







  const incCount = () => {
    let tempcount = count + 1;
    dispatch(setNotificationCount({ count: tempcount }))
  }

  const resetCount = () => {
    dispatch(setNotificationCount({ count: 0 }))
  }










  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen)

  const [openUser, setOpenUser] = React.useState(false);
  const [openContent, setOpenContent] = React.useState(false)
  const [openJobPortal, setOpenJobPortal] = React.useState(false)
  const [openInvestor, setOpenInvestor] = React.useState(false)

  const handleAllClose = () => {
    setOpenContent(false)
    setOpenUser(false);

    setOpenJobPortal(false)
    setOpenInvestor(false)
  }
  const handleUsersClick = () => {
    setOpenUser(!openUser);
    setOpenContent(false)
    setOpenJobPortal(false)
    setOpenInvestor(false)
  };

  const handleContentClick = () => {
    setOpenContent(!openContent)
    setOpenUser(false);

    setOpenJobPortal(false)
    setOpenInvestor(false)
  }

  const handleJobClick = () => {
    setOpenJobPortal(!openJobPortal)
    setOpenUser(false);
    setOpenContent(false)

    setOpenInvestor(false)
  }
  const handleInvestorClick = () => {
    setOpenInvestor(!openInvestor)
    setOpenUser(false);
    setOpenContent(false)
    setOpenJobPortal(false)

  }

  const navigate = useNavigate()

  const activeTab = (route) => {
    navigate(`${route}`)
    return {
      color: '#f6faff',
    }
  }

  // profile section  

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Profile Menu 

  const renderMenu = (
    <Menu
      sx={{ mt: isMenuOpen ? '49px' : '0px', }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose} sx={{ display: 'flex', gap: '10px', }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', }}>
          <Image
            publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1683702654/Ellipse_kqekbg.svg"
            cloudName="dxluokypg"
          />



        </Box>
        <Box >
          <Typography variant="h3" sx={{ fontSize: '12px' }}>{name}</Typography>
          <Typography variant="h4" sx={{ fontSize: '12px' }}>{user}</Typography>
          {/* <Typography variant="h4" sx={{ fontSize: '12px' }}>{details}</Typography> */}
        </Box>
      </MenuItem>
      {/* <MenuItem onClick={handleMenuClose} sx={{ gap: '5%' }}>
        <PersonOutlineIcon />My Profile
      </MenuItem> */}
      <MenuItem onClick={logout} sx={{ gap: '5%', mb: '5%', mt: '5%' }}>
        <LogoutIcon /> Logout
      </MenuItem>
    </Menu>
  );


  // profile working 

  const renderMobileMenu = (
    <Menu sx={{ mt: '25%' }}>
      <MenuItem onClick={handleProfileMenuOpen} sx={{ mt: '25%' }}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
          sx={{ mt: '25%' }}
        >
          <AccountCircle />
        </IconButton>
        <Typography variant="h6" sx={{ mt: '25%' }}>Profile</Typography>
      </MenuItem>
    </Menu>
  );


  const Search = styled("div")(({ theme }) => ({
    position: "relative",

    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    // marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    // [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(3),
    // width: "auto"
    // }
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "#1F384C",

    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      // transition: theme.transitions.create("width"),
      width: "100%"
    }
  }));


  return (
    <Box sx={{ display: "flex", justifyContent: 'space-evenly' }}>
      <CssBaseline />
      {/* navbar Responsive  */}
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: 'white', paddingBottom: '8px', boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)', }}
      >
        <Toolbar>
          <div>
            <Button sx={{ display: { xs: 'flex', sm: 'none', md: 'none', lg: 'none' }, fontSize: '1.175rem', p: 'none' }}>
              <FaBars onClick={toggle} />
            </Button>

          </div>
          <Link to='/dashboard' style={{marginTop:'0.5%'}}>
            <Image publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1682507755/KJSSCosmosAdmin_mprddf.svg" cloudName="dxluokypg"  />
          </Link>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'flex', md: 'flex', lg: 'flex' }, justifyContent: 'center', ml: { xs: '', sm: '', md: '10%', lg: '15%' } }}>
            <AppBar position="static" sx={{
              bgcolor: 'white', boxShadow: 'none'
            }}>
              <Toolbar >
                {/* <Search sx={{
                  bgcolor: '#F6F6FB',
                  "&:hover": {
                    backgroundColor: '#F6F6FB'
                  },
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <SearchIconWrapper sx={{ paddingLeft: '0px', paddingRight: '15px' }}>
                    <SearchIcon sx={{ color: '#627B87' }} />
                  </SearchIconWrapper>
                  <StyledInputBase sx={{ flexGrow: 1, marginLeft: '-25px', fontSize: '14px', color: '#627B87', '&::placeholder': { color: '#A8B5C2', textAlign: 'left', marginRight: '0px' } }} placeholder="Search…" />
                </Search> */}
              </Toolbar>
            </AppBar>
          </Box>

          {/* <ButtonGroup>
        <Button
          aria-label="increase"
          onClick={incCount}
        >
          <AddIcon fontSize="small" />
        </Button>
      </ButtonGroup> */}



          <Box sx={{ flexGrow: 1, }}>
            <AppBar position="static" sx={{ bgcolor: "transparent", boxShadow: 'none' }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1, }} />
                <Box sx={{
                  display: 'flex', alignItems: 'center', justifyContent: "center",
                  textAlign: "center",
                }}>
                  <IconButton
                    size="large"
                    edge="start"
                    aria-label="account of current user"
                    // aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                    sx={{ borderRadius: '0%', gap: { lg: '5px' }, display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
                  >
                    {/* <Image publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1683702654/Ellipse_kqekbg.svg" cloudName="dxluokypg" /> */}
                    <AccountCircleIcon sx={{ color: 'black' }} />


                    <Box sx={{ display: { xs: 'none', sm: 'flex', md: 'flex', lg: 'flex' }, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography sx={{ color: 'grey', textAlign: 'center', marginBottom: '2px' }}>{name}</Typography>
                      <KeyboardArrowDownIcon sx={{ color: 'grey' }} />
                    </Box>
                  </IconButton>
                </Box>
                {/* <IconButton sx={{ display: {xs:'none',sm:'flex',md:'flex',lg:'flex'},}} ><Image  publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1683702654/Notif_Icon_pm3pss.svg" cloudName="dxluokypg" /></IconButton> */}

                {/* Notification icon strat   */}


                <Link to='/notifications'>
                  <Badge color="secondary" badgeContent={count} onClick={resetCount}>
                    <NotificationsRoundedIcon sx={{ color: 'black', cursor: 'pointer' }} />
                  </Badge>
                </Link>



                {/* Notification icon end  */}
              </Toolbar>
            </AppBar>
            {renderMobileMenu}
            {renderMenu}
          </Box>

        </Toolbar>
      </AppBar>
      <Drawer
        variant={isMobile ? "temporary" : "persistent"}
        open={!isMobile || isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box"
          }
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto", pt: '24px', color: '#585858' }}>
          <List>
            <ListItem disablePadding onClick={() => { navigate('/dashboard'); handleAllClose() }}>
              <ListItemButton sx={{
                backgroundColor: location.pathname === '/dashboard' ? '#f6faff' : 'transparent',
                color: location.pathname === '/dashboard' ? 'darkblue' : 'inherit',
              }}>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <DashboardRoundedIcon sx={{
                    color: location.pathname === '/dashboard' ? 'darkblue' : 'inherit',
                  }} />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Dashboard</ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { navigate('/leadslist'); handleAllClose() }}
                sx={{
                  backgroundColor: location.pathname === '/leadslist' ? '#E3F5F' : 'transparent',
                  color: location.pathname === '/leadslist' ? 'darkblue' : 'inherit',
                }}>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <PersonRoundedIcon sx={{
                    color: location.pathname === '/leadslist' ? 'darkblue' : 'inherit',
                  }} />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Leads</ListItemText>
              </ListItemButton>
            </ListItem>


            {/* ---------------------------------------- */}
            <ListItem disablePadding>
              <ListItemButton onClick={handleInvestorClick} sx={{ backgroundColor: openInvestor ? "#f6faff" : "#ffffff" }}>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <NotificationsSharpIcon sx={{ color: openInvestor ? "darkblue" : "#585858" }} />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500', color: openInvestor ? "darkblue" : "#585858" }}>Investors</ListItemText>
              </ListItemButton>
            </ListItem>
            <Collapse in={openInvestor} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/interest')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/interest' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/interest' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Prospects</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            <Collapse in={openInvestor} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/request')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/request' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/request' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Request</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            {/* ---------------------------------------- */}



            <ListItem disablePadding onClick={() => { navigate('/ticket'); handleAllClose() }}>
              <ListItemButton sx={{
                backgroundColor: location.pathname === '/ticket' ? '#E3F5F' : 'transparent',
                color: location.pathname === '/ticket' ? 'darkblue' : 'inherit',
              }} >
                <ListItemIcon sx={{
                  minWidth: '40px',
                  color: location.pathname === '/ticket' ? 'darkblue' : 'inherit',
                }}>
                  {/* <Image publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1682490031/Ticket_wq60fu.svg" cloudName="dxluokypg" /> */}
                  <ConfirmationNumberRoundedIcon />
                </ListItemIcon >
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Ticket</ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding onClick={() => { navigate('/notifications'); handleAllClose() }}>
              <ListItemButton sx={{
                backgroundColor: location.pathname === '/notifications' ? '#E3F5F' : 'transparent',
                color: location.pathname === '/notifications' ? 'darkblue' : 'inherit',
              }}>
                <ListItemIcon sx={{
                  minWidth: '40px',
                  color: location.pathname === '/notifications' ? 'darkblue' : 'inherit',
                }}>
                  {/* <Image publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1682490032/Notif_d4dyqi.svg" cloudName="dxluokypg" /> */}
                  <NotificationsRoundedIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Notifications</ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={handleContentClick} >
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <ArticleRoundedIcon sx={{ color: openContent ? "darkblue" : "#585858" }} />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500', color: openContent ? "darkblue" : "#585858" }}>Content Management</ListItemText>
              </ListItemButton>
            </ListItem>
            <Collapse in={openContent} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/homepage')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/homepage' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/homepage' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Homepage</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            <Collapse in={openContent} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/investor')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/investor' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/investor' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Investor</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            <Collapse in={openContent} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/media')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/media' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/media' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Media</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            <Collapse in={openContent} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/contact_us')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/contact_us' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/contact_us' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Contact us</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            <ListItem disablePadding>
              <ListItemButton onClick={handleJobClick} sx={{ backgroundColor: openJobPortal ? "#f6faff" : "#ffffff" }}>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <BadgeRoundedIcon sx={{ color: openJobPortal ? "darkblue" : "#585858" }} />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500', color: openJobPortal ? "darkblue" : "#585858" }}>Job Portal</ListItemText>
              </ListItemButton>
            </ListItem>
            <Collapse in={openJobPortal} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/jobapplicants')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/jobapplicants' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/jobapplicants' ? 'darkblue' : 'inherit',
                  }}
                >
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Job Applicants</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
            <Collapse in={openJobPortal} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={() => navigate('/jobroles')}
                  sx={{
                    pl: 7,
                    backgroundColor: location.pathname === '/jobroles' ? '#E3F5F' : 'transparent',
                    color: location.pathname === '/jobroles' ? 'darkblue' : 'inherit',
                  }}>
                  <ListItemText primaryTypographyProps={{ fontSize: '15px', fontWeight: '500' }}>Manage Job Roles</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>
          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: { xs: '#ffff', sm: '#f9f9f9', md: '#f9f9f9', lg: '#f9f9f9' } }}>
        <Toolbar />


      {/* pages rendering  */}
        <Outlet/>


  {/* pages rendering  */}

      </Box>
    </Box>
  );
}

